import { render, staticRenderFns } from "./ManageColumnsMenu.vue?vue&type=template&id=0b449066"
import script from "./ManageColumnsMenu.vue?vue&type=script&lang=ts"
export * from "./ManageColumnsMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports